import { render, staticRenderFns } from "./MobileDeviceVerification.vue?vue&type=template&id=61b923b8"
import script from "./MobileDeviceVerification.vue?vue&type=script&lang=js"
export * from "./MobileDeviceVerification.vue?vue&type=script&lang=js"
import style0 from "./MobileDeviceVerification.vue?vue&type=style&index=0&id=61b923b8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports